import { useState, useEffect, useRef } from "react";
import { useDispatch } from 'react-redux';
import { callCommonAction } from "../../redux/Common/CommonReducer";
import { Tabs, Tab, Spinner } from "react-bootstrap"; // using react-bootstrap spinner
import { useNavigate, useLocation } from 'react-router-dom';

const ChatSystem = ({ rejectedData, setrejectedData = () => { }, currentUser, tabKey }) => {
    console.log(rejectedData,"rejectedData")
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const messagesEndRef = useRef(null);
    const [activeTab, setActiveTab] = useState("proposal");
    const [selectedDocument, setSelectedDocument] = useState(null);
      const navigate = useNavigate();
    
    useEffect(() => { messagesEndRef.current?.scrollIntoView({ behavior: "smooth" }) }, [rejectedData]);
    useEffect(() => {
        // When switching *from* comments *to* home, reset the selected document
        if (activeTab === "proposal") {
            setSelectedDocument(null);
        }
    }, [activeTab]);

    const handleDocumentClick = async (doc) => {
        try {
            setLoading(true);
            dispatch(callCommonAction({ loading: true }));

            // simulate API delay or do actual fetching here
            await new Promise((resolve) => setTimeout(resolve, 500)); // optional

            setSelectedDocument(doc);
            setActiveTab("comments");
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
            dispatch(callCommonAction({ loading: false }));
        }
    };
    const handleIconClick = (doc) => {
        navigate(`/update-proposal/${doc?.id}`);
        window.location.reload();
    }

    // Get file type icon
    const getFileTypeIcon = (fileType) => {
        switch (fileType) {
            case "pdf":
                return <iconify-icon icon="material-icon-theme:pdf" class="fs-1"></iconify-icon>
            case "excel":
            case "xlsx":
            case "xls":
                return <iconify-icon icon="vscode-icons:file-type-excel" class="fs-1"></iconify-icon>
            case "word":
            case "docx":
            case "doc":
                return <iconify-icon icon="vscode-icons:file-type-word" class="fs-1"></iconify-icon>
            default:
                return <iconify-icon icon="material-icon-theme:pdf" class="fs-1"></iconify-icon>
        }
    }

    return (
        <>
            <Tabs
                activeKey={activeTab}
                onSelect={(key) => setActiveTab(key)}
                id="uncontrolled-tab-example"
                className="mb-3 panel-tabs"
            >
                <Tab eventKey="proposal" title="Proposal">
                    <ul className="list-group doc-list">
                        {rejectedData.map((doc, index) => (
                            <li
                                key={index}
                                className="list-group-item list-group-item-action border-0 p-1 mb-1"
                            >
                                <div className="d-flex align-items-center gap-2 justify-content-between">
                                    <div className="d-flex align-items-center flex-fill gap-2">
                                        <span className="symbol-60 d-inline-flex align-items-center justify-content-center pointer"
                                            onClick={() => handleIconClick(doc)}
                                            >
                                            {getFileTypeIcon(doc.type)}
                                        </span>
                                        <h2 className="fs-12 fw-normal text-body m-0">{doc.title}</h2>
                                    </div>
                                    <div>
                                    <iconify-icon onClick={() => handleDocumentClick(doc)} icon="ic:outline-comment" class="fs-5 yellow pointer"></iconify-icon>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </Tab>

                <Tab eventKey="comments" title="Comments">
                    {loading ? (
                        <div className="d-flex justify-content-center align-items-center p-4">
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>
                        </div>
                    ) : selectedDocument?.rejected_comment ? (
                        <div className="p-3 bg-white rounded border shadow-sm text-muted comment-box">
                            <div className="fs-12 fw-medium mb-2">
                                {selectedDocument.rejected_comment}
                            </div>
                        </div>
                    ) : (
                        <div className="p-3 text-muted text-center">No rejected comment selected.</div>
                    )}
                </Tab>
            </Tabs>
        </>
    );

};

export default ChatSystem;
